export default __webpack_public_path__ + "static/media/bb_guess_0.8e9e8647.png";